import React from "react";
import { Text } from "@salestrak/ui";
import type { ActivityChange } from "../activity-types";
import { countOf } from "#app/lib/utils/pluralize";
import { AttachmentsLink } from "./attachments-chunk";

export function FieldPhotosChunk({ change }: { change: ActivityChange }) {
  const ids: string[] = Array.isArray(change.newValue) ? change.newValue : [];
  const count = ids.length;
  return (
    <Text size="sm">
      {change.action}{" "}
      {change.action === "added" ? (
        <AttachmentsLink ids={ids} label={change.target.label} />
      ) : count === 1 ? (
        "a photo"
      ) : (
        countOf(count, "photo")
      )}{" "}
      {change.action === "added" ? "to" : "from"} custom field <Text size="sm">{change.target.label}</Text>
    </Text>
  );
}
